import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PaginationAlignments } from "../../../../Constant";
import { StaticPaginationAlignment } from "./StaticPaginationAlignment";
import { ALIGNMENT_PAGINATIONS } from "../../../../Data/Bonus Ui/Paginations";
import { DynamicPaginationAlignment } from "./DynamicPaginationAlignment";

const PaginationAlignment = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={PaginationAlignments} span={ALIGNMENT_PAGINATIONS} />
        <CardBody>
          <StaticPaginationAlignment />
          <DynamicPaginationAlignment/>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PaginationAlignment;
